// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"33c9d826","366":"c5fbbfc3","409":"4804403a","503":"73ba7ef6","823":"4983492d","846":"232d3cfe","904":"059739f8"}[chunkId] + ".chunk.js";
};